import menudata from '../Menu/Menu.data';

export default {
    ...menudata,
};
